import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const postUsers = ({ first_name, last_name, email, password, phone, address }) => ({ type: "POST_USERS", first_name, last_name, email, password, phone, address })
export const postUsersRequest = () => ({ type: "POST_USERS_REQUEST" })
export const postUsersSuccess = payload => ({ type: "POST_USERS_SUCCESS", payload })
export const postUsersFailed = error => ({ type: "POST_USERS_FAILED", error })

export function* postUsersSaga({ 
    first_name, last_name, email, password, phone, address
}) {
    yield put(postUsersRequest())
    try {
        let { data: payload } = 
            yield call(axios,{ data: { first_name, last_name, email, password, phone, address }, url: "/users", method: "post" })
        yield put(postUsersSuccess(payload))
    } catch(err){
        yield put(postUsersFailed(err))
    }
}

export const patchUsers = ({ id, first_name, last_name, email, password, phone, address, onSuccess }) => ({ type: "PATCH_USERS", id, first_name, last_name, email, password, phone, address, onSuccess })
export const patchUsersRequest = () => ({ type: "PATCH_USERS_REQUEST" })
export const patchUsersSuccess = payload => ({ type: "PATCH_USERS_SUCCESS", payload })
export const patchUsersFailed = error => ({ type: "PATCH_USERS_FAILED", error })

export function* patchUsersSaga({ 
    id, first_name, last_name, email, password, phone, address, onSuccess
}) {
    yield put(patchUsersRequest())
    try {
        let { data: payload } = 
            yield call(axios,{ data: { first_name, last_name, email, password, phone, address }, url: "/users/" + id, method: "patch" })
        yield put(patchUsersSuccess(payload))
        if (onSuccess) yield call(onSuccess)
    } catch(err){
        yield put(patchUsersFailed(err))
    }
}

export default function* usersSagaWatcher() {
    yield takeEvery("POST_USERS", postUsersSaga)
    yield takeEvery("PATCH_USERS", patchUsersSaga)
}